module.exports = __webpack_public_path__ + "static/media/points.f8c41435.svg";